export enum ExternalInvoiceBalanceModifierReference {
  BankPayment = 'bankPayment',
  ContactBalancePayment = 'contactBalancePayment',
  DaybookTransaction = 'daybookTransaction',
  /* Invoice from Zervant */
  ExternalInvoice = 'externalInvoice',
  /* Invoice from Billy */
  Invoice = 'invoice',
  InvoiceLateFee = 'invoiceLateFee',
  CreditNote = 'creditnote',
}
